import type { TypographyProps } from '@components/atoms';
import { Stack, Typography } from '@components/atoms';
import type { FC, ReactNode } from 'react';

interface DataItemProps {
  label: string;
  value: string | number | ReactNode;
  unit?: string;
  color?: TypographyProps['color'];
}

export const DataItem: FC<DataItemProps> = ({ value, label, unit, color }) => {
  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center' marginTop={0.5}>
      <Typography variant='body2' color={color}>
        {label}
      </Typography>
      <Typography variant='body2' color={color} fontWeight='bold'>
        {value}
        {unit ? ` ${unit}` : null}
      </Typography>
    </Stack>
  );
};
